import * as React from "react";

const HatIcon = ({ width = "233", height = "201" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 233 201"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="hat-icon">
      <g opacity="0.2" clipPath="url(#clip0_749_1839)">
        <path
          d="M86.2574 36.6652L190.851 49.5689L123.913 130.42L21.2772 117.677L86.2574 36.6652Z"
          stroke="#696969"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M105.249 83.9512L154.852 89.5911L185.959 167.041"
          stroke="#696969"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M48.2258 121.766L63.0425 158.656C122.082 185.596 163.614 168.593 187.997 108.469L172.974 71.0651"
          stroke="#696969"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_749_1839">
          <rect
            width="186.254"
            height="161.655"
            fill="white"
            transform="translate(0 69.417) rotate(-21.8824)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HatIcon;
